// extracted by mini-css-extract-plugin
module.exports = {"input":"sendJobModal_input__bP6h6","button":"sendJobModal_button__2XbI1"};